import { useEffect, useState } from "react";
import { getUsers } from "../api/users";

let cache = null;
let inflight = null;

// Fetches the user directory once per session and exposes it as an id -> user map.
export default function useUsersMap() {
  const [usersById, setUsersById] = useState(cache || {});
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    let active = true;
    if (cache) {
      setUsersById(cache);
      setLoading(false);
      return;
    }
    if (!inflight) {
      inflight = getUsers()
        .then((res) => {
          const list = Array.isArray(res.data) ? res.data : res.data?.users || [];
          const map = {};
          list.forEach((u) => {
            map[u.id] = u;
          });
          cache = map;
          return map;
        })
        .catch(() => {
          cache = {};
          return {};
        });
    }
    inflight.then((map) => {
      if (active) {
        setUsersById(map);
        setLoading(false);
      }
    });
    return () => {
      active = false;
    };
  }, []);

  return { usersById, loading };
}
